export default function YouTubeEmbed({ videoId, title = "Watch" }) {
  if (!videoId) return null;
  return (
    <div className="my-10" data-testid={`youtube-embed-${videoId}`}>
      <div className="label text-pfc-gold mb-3">▶ {title}</div>
      <div className="relative w-full overflow-hidden" style={{ paddingTop: "56.25%", borderRadius: 12 }}>
        <iframe
          title={`YouTube ${videoId}`}
          src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
          className="absolute inset-0 w-full h-full"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
        />
      </div>
    </div>
  );
}
